import { useState } from 'react';
import { Box, Paper, Slide } from '@mui/material';
import CustomDFMessengerChat from './CustomDFMessengerChat';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../actions';
import { CHATS, PRIVACY, PRIVACY_POLICY, SIGNUP } from '../../constants/routes';
import { useLocation } from 'react-router-dom';
const noChatPages = [SIGNUP, PRIVACY, CHATS, PRIVACY_POLICY];
const DFMessengerChatBubble = () => {
  const location = useLocation();
  const organization = useSelector((state) => state.app.organization);
  const isSupportChatBotOpen = useSelector((state) => state.app.isSupportChatBotOpen);
  const appDispatch = useDispatch();

  const { healthSoftware, services } = organization || {};
  const [hover, setHover] = useState(false);

  const shouldShowChat = () => {
    const isAllowedPage = !noChatPages.includes(location.pathname);
    const isMacenaSoftware = healthSoftware?.name === 'macena';
    const hasSupportBotService = services?.supportBot;

    return isAllowedPage && isMacenaSoftware && hasSupportBotService;
  };
  const handleToggle = () => {
    appDispatch({
      type: actions.isSupportChatBotOpen,
      isSupportChatBotOpen: !isSupportChatBotOpen,
    });
  };

  return shouldShowChat() ? (
    <Box
      sx={{
        position: 'fixed',
        right: 0,
        bottom: 30,
        zIndex: 1000,
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Slide direction="left" in={isSupportChatBotOpen} mountOnEnter unmountOnExit timeout={800}>
        <Box
          sx={{
            mb: 1,
            mr: 1,
            width: '100%',
            height: '70dvh',
            maxHeight: '600px',
            maxWidth: '400px',
            minWidth: '400px',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <CustomDFMessengerChat />
        </Box>
      </Slide>

      <Box
        sx={{
          transform: isSupportChatBotOpen || hover ? 'translateX(0)' : 'translateX(50%)',
          transition: 'transform 0.3s ease',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Paper
          elevation={4}
          sx={{
            p: 1.5,
            borderRadius: '30px 0 0 30px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'primary.main',
            color: '#fff',
            cursor: 'pointer',
            opacity: isSupportChatBotOpen || hover ? 1 : 0.6,
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            width: 60,
            height: 60,
            justifyContent: 'center',
          }}
          onClick={handleToggle}
        >
          <img src="/supportAgentIcon.svg" alt="Chat" width={32} height={32} />
        </Paper>
      </Box>
    </Box>
  ) : null;
};

export default DFMessengerChatBubble;
